import axiosClient from "./axiosClient";

const taxReportApi = {
  CheckQuantityTaxReportFile: (customerId, reportTemplateId, year, quarter) => {
    return axiosClient.post(
      `/tax_report/check-quantity-tax-report_file`,
      {
        customerId,
        reportTemplateId,
        year,
        quarter,
      },
      {
        withCredentials: true,
      },
    );
  },
  GetReportFileByCustomer: (customerId, reportTemplateId, year, quarter) => {
    return axiosClient.post(
      `/tax_report/get-report-file-by-customer`,
      {
        customerId,
        reportTemplateId,
        year,
        quarter,
      },
      {
        withCredentials: true,
      },
    );
  },
  DownloadFile: (customerId, fileId) => {
    return axiosClient.post(
      "/tax_report/download-report",
      {
        customerId,
        fileId,
      },
      {
        withCredentials: true,
        responseType: "blob",
      },
    );
  },
  DeleteFile: (customerId, fileId) => {
    console.log(customerId, fileId);

    return axiosClient.post(
      "/tax_report/delete-report",
      {
        customerId,
        fileId,
      },
      {
        withCredentials: true,
      },
    );
  },
};

export default taxReportApi;
